package ai.wagemix.pages

import ai.wagemix.analytics.WMCta
import ai.wagemix.analytics.WMCtaLocation
import ai.wagemix.analytics.sendWMCtaClicked
import ai.wagemix.SiteLogo
import ai.wagemix.ThemeToggle
import ai.wagemix.di.koin
import ai.wagemix.logic.WMRoutes
import ai.wagemix.siteStrings
import ai.wagemix.web.components.WMButton
import ai.wagemix.web.components.WMButtonSize
import ai.wagemix.web.screens.sharedmix.WMDefaultSharedMixWebViewModel
import ai.wagemix.web.screens.sharedmix.WMSharedMixScreen
import ai.wagemix.web.theme.WMContentWidthVar
import ai.wagemix.web.theme.WMPreviewHeightVar
import ai.wagemix.web.theme.WMPreviewPaddingVar
import ai.wagemix.web.theme.WMPreviewWidthVar
import androidx.compose.runtime.Composable
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.web.screens.FSPageScaffold
import com.fsryan.foundation.web.theme.fs
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.px
import org.koin.core.parameter.parametersOf

/** Penpot `Shared mix`: a public recipient view with its own minimal header; `?renderingMode=preview` is the 1200×630 card. */
@Page(routeOverride = "/s/mix/{id}")
@Composable
fun SharedMixPage(ctx: PageContext) {
    val s = siteStrings
    val id = ctx.route.params["id"]
    val preview = ctx.route.params["renderingMode"] == "preview"
    val colors = ColorMode.current.toPalette().fs
    val screen: @Composable () -> Unit = {
        WMSharedMixScreen(
            createViewModel = { koin.get<WMDefaultSharedMixWebViewModel> { parametersOf(id ?: "") } },
            sharedMixId = id,
            strings = s,
            preview = preview,
            onCtaClick = { sharedMixCtaClicked(ctx) }
        )
    }
    if (preview) {
        Box(
            Modifier.width(WMPreviewWidthVar.value())
                .height(WMPreviewHeightVar.value())
                .padding(WMPreviewPaddingVar.value())
                .overflow(Overflow.Hidden)
                .backgroundColor(colors.background)
        ) { screen() }
    } else {
        FSPageScaffold(
            contentMaxWidth = WMContentWidthVar.value(),
            header = {
                Row(
                    modifier = Modifier.fillMaxWidth().maxWidth(WMContentWidthVar.value()).padding(16.px).gap(12.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SiteLogo()
                    Box(Modifier.fillMaxWidth())
                    ThemeToggle()
                    WMButton(s.sharedMix.ctaButton, size = WMButtonSize.Sm) { sharedMixCtaClicked(ctx) }
                }
            }
        ) { screen() }
    }
}

/** "Try Wagemix", in the header or the page: reported, then on to the landing page. */
private fun sharedMixCtaClicked(ctx: PageContext) {
    FSLog.sendWMCtaClicked(cta = WMCta.StartMixing, location = WMCtaLocation.SharedMix)
    ctx.router.navigateTo(WMRoutes.HOME)
}
